<template>
  <div id="Lgx02667289386568940257518">
    <vx-card class="relative flex justify-center items-center p-10">
      <img
        src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/02667289386568940257518/sim-graphic.png"
        alt="Logo"
        draggable="false"
        class="px-12"
      />

      <div class="">
        <div class="flex items-center gap-48 mt-8">
          <span class="flex gap-4 w-1/2">
            <v-select disabled class="w-1/2" v-model="options.one" />
            <v-select class="w-1/2" id="select-0" :options="options.two" v-model="answers[0].value" placeholder="Select MAC Address" />
          </span>

          <span class="flex gap-4 w-1/2">
            <v-select disabled class="w-full" v-model="options.three" />
            <v-select class="w-full" id="select-1" :options="options.four" v-model="answers[1].value" placeholder="Select MAC Address" />
          </span>
        </div>

        <div class="flex items-center gap-48 mt-12">
          <span class="flex gap-4 w-1/2">
            <v-select class="w-1/2" id="select-2" :options="options.five" v-model="answers[2].value" placeholder="Select IP Address" />
            <v-select disabled class="w-1/2" v-model="options.six" />
          </span>

          <span class="flex gap-4 w-1/2">
            <v-select disabled class="w-full" v-model="options.seven" />
            <v-select disabled class="w-full" v-model="options.eight" />
          </span>
        </div>

        <div class="flex items-center gap-48 mt-12">
          <span class="flex gap-4 w-1/2">
            <v-select class="w-1/2" id="select-3" :options="options.nine" v-model="answers[3].value" placeholder="Select VLAN" />
            <v-select class="w-1/2" id="select-4" :options="options.ten" v-model="answers[4].value" placeholder="Select VLAN" />
          </span>

          <span class="flex gap-4 w-1/2">
            <v-select disabled class="w-full" v-model="options.eleven" />
            <v-select class="w-full" id="select-5" :options="options.twelve" v-model="answers[5].value" placeholder="Select VLAN" />
          </span>
        </div>

        <div class="flex items-center gap-48 mt-12">
          <span class="flex gap-4 w-1/2">
            <v-select class="w-1/2" id="select-6" :options="options.thirteen" v-model="answers[6].value" placeholder="Select Interface" />
            <v-select class="w-1/2" id="select-7" :options="options.fourteen" v-model="answers[7].value" placeholder="Select Interface" />
          </span>

          <span class="flex gap-4 w-1/2">
            <v-select disabled class="w-full" v-model="options.fifteen" />
            <v-select class="w-full" id="select-8" :options="options.sixteen" v-model="answers[8].value" placeholder="Select Interface" />
          </span>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      answers: [
        {
          value: null,
          answer: '0200.0000.0003',
        },
        {
          value: null,
          answer: '0200.0000.0003',
        },
        {
          value: null,
          answer: '0200.0000.0003',
        },
        {
          value: null,
          answer: '0200.0000.0003',
        },
        {
          value: null,
          answer: '0200.0000.0003',
        },
        {
          value: null,
          answer: '0200.0000.0003',
        },
        {
          value: null,
          answer: '0200.0000.0003',
        },
        {
          value: null,
          answer: '0200.0000.0003',
        },
        {
          value: null,
          answer: '0200.0000.0003',
        },
      ],

      options: {
        one: '0200.0000.0003', // Disabled Option
        two: [
          '0200.000.0002',
          '0200.000.0003',
          '0200.000.0004',
          '0200.000.0005',
          '0200.000.0006',
          '0200.000.0007',
          '0200.000.0008',
          '0200.000.0009',
        ],
        three: 'Previously inventoried', // Disabled Option
        four: [
          '0200.000.0002',
          '0200.000.0003',
          '0200.000.0004',
          '0200.000.0005',
          '0200.000.0006',
          '0200.000.0007',
          '0200.000.0008',
          '0200.000.0009',
        ],
        five: ['10.10.30.51', '10.10.30.52', '10.10.30.53', '10.10.30.54', '10.10.60.51', '10.10.60.52', '10.10.60.53', '10.10.60.54'],
        six: '10.10.30.51', // Disabled Option
        seven: 'Previously inventoried', // Disabled Option
        eight: '10.10.30.53', // Disabled Option
        nine: ['10', '20'],
        ten: ['10', '20'],
        eleven: 'Previously inventoried', // Disabled Option
        twelve: ['10', '20'],
        thirteen: ['GigabitEthernet0/1', 'GigabitEthernet0/2', 'GigabitEthernet0/3', 'GigabitEthernet0/4'],
        fourteen: ['GigabitEthernet0/1', 'GigabitEthernet0/2', 'GigabitEthernet0/3', 'GigabitEthernet0/4'],
        fifteen: 'Previously inventoried', // Disabled Option
        sixteen: ['GigabitEthernet0/1', 'GigabitEthernet0/2', 'GigabitEthernet0/3', 'GigabitEthernet0/4'],
      },
    };
  },
  methods: {
    markSimulation() {
      let totalScore = 0;

      this.answers.forEach((answer, index) => {
        if (answer.value === answer.answer) {
          document.querySelector(`#select-${index}`).classList.add('correct-border');
          totalScore++;
        } else {
          document.querySelector(`#select-${index}`).classList.add('invalid-border');
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
#Lgx02667289386568940257518 {
  .port {
    position: absolute;
    border: 1px solid transparent;
    cursor: url('~@/assets/images/cursor/cursor-pointer.png'), auto;
  }

  .correct-border {
    border: 1px solid #31b952 !important;
  }

  .invalid-border {
    border: 1px solid #c93738 !important;
  }

  .vs__selected {
    color: #969ea7 !important;
  }
}
</style>
